<template>
    <div>
        <div class="list-con">
            <el-table ref="filterTable" :data="tabelData" tooltip-effect="dark" style="width: 100%">
                <el-table-column :prop="item.key" :label="item.label" v-for="item in dataSource" :key="item.key"
                    :width="item.width || ''">
                    <template slot-scope="scope">
                        <div class="text" v-if="!slotmap.includes(item.key)">
                            {{ scope.row[item.key] }}
                        </div>
                        <div class="text" v-else-if="item.key == 'create_time'">
                            {{ formatDate(scope.row[item.key]) }}
                        </div>
                        <div class="edit-menu" v-else-if="item.key == 'edit'">
                            <div class="edit-item" @click="edititem(scope.row)">编辑</div>
                            <div class="del-item" @click="delitem(scope.row)">删除</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination background layout="prev, pager, next" :total="numdata"
            style="margin-top: 30px; float: right; margin-right: 60px" :current-page="current_page"
            :page-size="page_size" @current-change="handleCurrentChange" @prev-click="handleCurrentChange_prev"
            @next-click="handleCurrentChange_next">
        </el-pagination>
        <el-dialog :visible.sync="partvisible"
                    :modal-append-to-body="true"
                    custom-class="edit-dialog"
                    @close="dialogclose"
                    :destroy-on-close="true" 
                    :close-on-click-modal ="false"
                    width="720px"
                    :title="isadd ? '新增款号' : '编辑款号' ">
            <div v-if="isadd" class="edit-content">
                <div class="edit-item">
                    <div class="text" style="margin-bottom: 24px;">
                        款号名称：
                    </div>
                    <el-input v-model="addname" placeholder="请输入款号名称" ></el-input>
                </div>
            </div>
            <div v-else class="edit-content">
                <div class="edit-item">
                    <div class="text" style="margin-bottom: 24px;">
                        款号名称：
                    </div>
                    <el-input v-model="selectrow.name" placeholder="请输入新的款号名称"></el-input>
                </div>
            </div>
            <div class="edit-content" v-if="isadd">
                <div class="edit-item">
                    <div class="text" style="margin-bottom: 24px;">
                        标识名称：
                    </div>
                    <el-input v-model="other_name" placeholder="请输入标识名称"></el-input>
                </div>
            </div>
            <div class="edit-content" v-else>
                <div class="edit-item">
                    <div class="text" style="margin-bottom: 24px;">
                        标识名称：
                    </div>
                    <el-input v-model="selectrow.other_name" placeholder="请输入标识名称"></el-input>
                </div>
            </div>
            <div slot="footer">
                <div class="button-group">
                    <el-button type="info" size="small" @click="dialogclose"
                        >取消</el-button
                    >
                    <el-button type="primary" size="small" @click="adds"
                        >确定</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { addStyle, updateStyle, deleteStyle, getStyleList } from '@/api/index'
export default {
    data() {
        return {
            dataSource: [
                { label: "款号名称", key: "name", width: '' },
                { label: "id", key: "id" },
                { label: "标识", key: "other_name" },
                { label: "创建时间", key: "create_time" },
                { label: "操作", key: "edit" },
            ],
            tabelData: [],
            editvisible: false,
            selectrow: {},
            slotmap: ["create_time", 'edit'],
            centerDialogVisible: false,
            centerDialogVisible_image: "",
            numdata: 0,
            current_page: 1,
            page_size: 8,
            partvisible: false,
            isadd: false,
            addname: '',
            other_name: ''
        }
    },
    methods: {
        handleCurrentChange_next() {
            this.current_page += 1;
        },
        handleCurrentChange_prev() {
            this.current_page -= 1;
        },
        handleCurrentChange(val) {
            this.current_page = val;
            this.getList();
        },
        dialogclose() {
            this.partvisible = false
            this.isadd = false
        },
        getList() {
            let params = {
                limit: this.page_size,
                page: this.current_page,
            }
            getStyleList(params).then(res => {
                if (res.code == 1) {
                    this.tabelData = res.data.list
                    this.numdata = res.data.total
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        formatDate(value) {// 时间戳转换日期格式方法
            if (value == null) {
                return '';
            } else {
                value = value * 1000
                let date = new Date(value);
                let y = date.getFullYear();// 年
                let MM = date.getMonth() + 1;// 月
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();// 日
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();// 时
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();// 分
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();// 秒
                s = s < 10 ? ('0' + s) : s;
                return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            }
        },
        delitem(row) {
            this.$confirm(
                '确认删除款号方案吗?',
                '警告',
                {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            ).then(() => {
                var forms = {
                    id: row.id,
                }
                deleteStyle(forms).then(res => {
                    if (res.code == 1) {
                        //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
                        this.$message.success(res.msg);
                        this.getList();
                    } else {
                        this.$message.warning("删除失败!");
                    }
                });
            }).catch((err) => {
                Message.warning('取消操作');
            })
        },
        edititem(row) {
            this.selectrow = JSON.parse(JSON.stringify(row))
            this.partvisible = true
        },
        adds() {
            let method = this.isadd ? addStyle : updateStyle
            let params = {}
            if (this.isadd) {
                params.name = this.addname
                params.other_name = this.other_name
            } else {
                params.id = this.selectrow.id
                params.name = this.selectrow.name
                params.other_name = this.selectrow.other_name
            }
            method(params).then(res => {
                if (res.code == 1) {
                    this.$message.success(res.msg);
                    this.dialogclose()
                    this.getList();
                } else {
                    this.$message.warning(res.msg);
                }
            })
        },
        addStyles() {
            this.isadd = true
            this.partvisible = true
        }
    },
    mounted() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.tab-menu {
    display: flex;
    align-items: center;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 14px;
    color: #507af9;
    column-gap: 13px;

    .line {
        width: 1px;
        height: 12px;
        background: #e6e6e6;
    }

    .edit {
        cursor: pointer;
    }

    .delbtn {
        cursor: pointer;
        color: #f95050;
    }
}

.content {
    color: #f95050;
}

.edit-menu {
    display: flex;
    align-items: center;
    column-gap: 16px;

    .edit-item {
        cursor: pointer;
        color: #409EFF;
    }

    .del-item {
        cursor: pointer;
        color: #f95050;
    }
}
</style>
<style lang="scss">
.part-dialog {

}
</style>